import { Button, Dialog, DialogContent, DialogTitle, Divider, Drawer, Tooltip } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'

import DataGrid from 'src/common/components/DataGrid'
import CyberSwitch from 'src/common/components/Switch'
import TemplateView from 'src/views/TemplateView'
import DifficultyChip from 'src/common/components/DifficultyChip'

import templatesService from 'src/services/templates.service'
import Highlighter from 'react-highlight-words'
import { useNavigate } from 'react-router-dom'

import './style.css'
import Spacer from 'src/common/components/Spacer'
import { CloseDrawer } from 'src/common/icons/closeDrawer'
import { ValueAndUnit } from '../overview'
import PuzzileIcon from 'src/common/icons/puzzileIcon'
import { parseJwt } from 'src/heplers'
import companyService from 'src/services/company.service'
import CustomCheckbox from 'src/common/components/CustomCheckbox'
import { SnackBarContext } from 'src/App'
import customToastWithAlert from '../../common/components/CustomToastWithAlert'
import CustomTemplatePreview from '../manual-simulation/components/templatePreview'
// import { disableTime } from 'rsuite/esm/internals/utils/date'

const columns = langs => [
  {
    headerName: 'Name',
    total: false,
    width: 300,
    field: 'subject',
    renderCell: ({ row, action, search }) => (
      <div className='row' style={{ alignItems: 'center' }}>
        <div style={{}} className='column'>
          <Tooltip title={row.subject} arrow>
            <p
              onClick={() => action(row.id)}
              className='template-name'
              style={{
                fontWeight: '600',
                fontSize: '16px',
                marginBottom: '8px',
                cursor: 'pointer'
              }}
            >
              <Highlighter
                highlightClassName='highlight-text'
                searchWords={[search]}
                autoEscape={true}
                textToHighlight={row.subject}
              />
            </p>
          </Tooltip>
          <p style={{ fontSize: '13px', color: '#76767F' }}>
            <Highlighter
              highlightClassName='highlight-text'
              searchWords={[search]}
              autoEscape={true}
              textToHighlight={row.name}
            />
          </p>
        </div>
      </div>
    )
  },
  {
    field: 'level',
    headerName: 'Difficulty',
    width: 150,
    editable: true,
    renderCell: ({ row }) => <DifficultyChip level={row.level} />,
    filterOptions: ['LOW', 'HIGH', 'MEDIUM']
  },
  {
    headerName: 'Category',
    width: 200,
    field: 'types',
    editable: true,
    filterOptions: ['Credential theft', 'Financial fraud', 'Spear Phishing', 'Malware delivery', 'Internal BEC'],
    renderCell: ({ row }) => <p>{row?.types.join(', ') || ''}</p>
  },
  {
    renderCell: ({ row }) => (
      <Tooltip title={row.departments.join(', ')} arrow>
        <p>
          {row.departments.join(', ').length > 30
            ? row.departments.join(', ').slice(0, 30) + '...'
            : row.departments.join(', ')}
        </p>
      </Tooltip>
    ),
    headerName: 'Job function',
    field: 'departments',
    width: 150,
    editable: true,
    filterOptions: [
      'Administration',
      'Business Development',
      'Customer Service',
      'Finance',
      'Human Resources (HR)',
      'Information Technology (IT)',
      'Legal',
      'Marketing',
      'Operations',
      'Sales'
    ]
  },
  {
    renderCell: ({ row }) => <p>{row.locations.join(', ')}</p>,
    headerName: 'Country',
    field: 'locations',
    width: 110,
    editable: true,
    filterOptions: [
      'Austria',
      'Belgium',
      'Bulgaria',
      'Croatia',
      'Czech Republic',
      'Denmark',
      'Estonia',
      'Finland',
      'France',
      'Germany',
      'Greece',
      'Hungary',
      'Ireland',
      'Italy',
      'Latvia',
      'Lithuania',
      'Luxembourg',
      'Malta',
      'Netherlands',
      'Poland',
      'Portugal',
      'Republic of Cyprus',
      'Romania',
      'Slovakia',
      'Slovenia',
      'Spain',
      'Sweden',
      'UK',
      'US'
    ]
  },
  {
    renderCell: ({ row }) => <p>{row.language}</p>,
    headerName: 'Language',
    field: 'language',
    width: 150,
    editable: true,
    isLast: true,
    filterOptions: langs
  }
]

const columnsCustom = [
  {
    headerName: 'Subject',
    total: false,
    width: 300,
    field: 'subject',
    renderCell: ({ row, action, search }) => (
      <div className='row' style={{ alignItems: 'center' }}>
        <div style={{}} className='column'>
          <Tooltip title={row.subject} arrow>
            <p
              onClick={() => action(row.id)}
              className='template-name'
              style={{
                fontWeight: '600',
                fontSize: '16px',
                marginBottom: '8px',
                cursor: 'pointer'
              }}
            >
              <Highlighter
                highlightClassName='highlight-text'
                searchWords={[search]}
                autoEscape={true}
                textToHighlight={row.subject}
              />
            </p>
          </Tooltip>
          <p style={{ fontSize: '13px', color: '#76767F' }}>
            <Highlighter
              highlightClassName='highlight-text'
              searchWords={[search]}
              autoEscape={true}
              textToHighlight={row.name}
            />
          </p>
        </div>
      </div>
    )
  },
  {
    headerName: 'Name',
    width: 200,
    field: 'name',
    editable: true,
    renderCell: ({ row }) => <p>{row?.name || ''}</p>
  },
  {
    headerName: 'Sender',
    width: 200,
    field: 'sender',
    editable: true,
    renderCell: ({ row }) => <p>{row?.sender || ''}</p>
  },
  {
    headerName: 'Domain',
    width: 200,
    field: 'emailDomain',
    editable: true,
    renderCell: ({ row }) => <p>{row?.emailDomain || ''}</p>
  }
]

const BulkActions = ({ onActivate = () => {}, activateAllChecked }) => {
  return (
    <div className='row row-center'>
      <p
        style={{
          color: '#1B1B26',
          fontWeight: '400',
          fontSize: '16px',
          marginRight: '12px'
        }}
      >
        {!activateAllChecked ? 'Activate All' : 'Deactivate All'}
      </p>
      <CyberSwitch checked={activateAllChecked} onChange={onActivate} sx={{ mr: '30px' }} />
    </div>
  )
}

const Actions = ({ onChange, active, loading }) => {
  return (
    <div className='row row-center' style={{ marginRight: 20 }}>
      <CustomCheckbox disabled={loading} checked={active} onClick={onChange} />
      <span>Show all templates</span>
    </div>
  )
}

const EmptyTemplates = () => (
  <>
    <svg width='120' height='120' viewBox='0 0 120 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M105 33.75H72.4999C71.6886 33.75 70.8991 33.4868 70.25 33L57.25 23.25C56.6009 22.7632 55.8114 22.5 55.0001 22.5H33.75C33.2575 22.5 32.7699 22.597 32.3149 22.7854C31.86 22.9739 31.4466 23.2501 31.0983 23.5983C30.7501 23.9466 30.4739 24.36 30.2854 24.8149C30.097 25.2699 30 25.7575 30 26.25V37.5H40.0001C40.8114 37.5 41.6009 37.7632 42.25 38.25L55.25 48C55.8991 48.4868 56.6886 48.75 57.4999 48.75H90C90.4925 48.75 90.9801 48.847 91.4351 49.0354C91.89 49.2239 92.3034 49.5001 92.6517 49.8483C92.9999 50.1966 93.2761 50.61 93.4646 51.0649C93.653 51.5199 93.75 52.0075 93.75 52.5V82.5H105.417C105.854 82.5 106.288 82.4138 106.692 82.2463C107.097 82.0788 107.464 81.8333 107.774 81.5237C108.083 81.2142 108.329 80.8467 108.496 80.4423C108.664 80.0379 108.75 79.6044 108.75 79.1667V37.5C108.75 37.0075 108.653 36.5199 108.465 36.0649C108.276 35.61 108 35.1966 107.652 34.8483C107.303 34.5001 106.89 34.2239 106.435 34.0354C105.98 33.847 105.492 33.75 105 33.75Z'
        fill='#E7E7EE'
      />
      <path
        d='M93.75 52.5V94.1667C93.75 95.0507 93.3988 95.8986 92.7737 96.5237C92.1486 97.1488 91.3007 97.5 90.4167 97.5H18.75C17.7554 97.5 16.8016 97.1049 16.0984 96.4017C15.3951 95.6984 15 94.7446 15 93.75V41.25C15 40.2554 15.3951 39.3016 16.0984 38.5984C16.8016 37.8951 17.7554 37.5 18.75 37.5H40C40.8114 37.5 41.6009 37.7632 42.25 38.25L55.25 48C55.8991 48.4868 56.6886 48.75 57.5 48.75H90C90.9946 48.75 91.9484 49.1451 92.6517 49.8484C93.3549 50.5516 93.75 51.5054 93.75 52.5Z'
        stroke='#E7E7EE'
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M30 37.5V26.25C30 25.2554 30.3951 24.3016 31.0984 23.5984C31.8016 22.8951 32.7554 22.5 33.75 22.5H55C55.8114 22.5 56.6009 22.7632 57.25 23.25L70.25 33C70.8991 33.4868 71.6886 33.75 72.5 33.75H105C105.995 33.75 106.948 34.1451 107.652 34.8484C108.355 35.5516 108.75 36.5054 108.75 37.5V79.1667C108.75 79.6044 108.664 80.0379 108.496 80.4423C108.329 80.8467 108.083 81.2142 107.774 81.5237C107.464 81.8332 107.097 82.0787 106.692 82.2463C106.288 82.4138 105.854 82.5 105.417 82.5H93.75'
        stroke='#E7E7EE'
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
    <p style={{ textAlign: 'center', color: '#76767F' }}>No templates found</p>
  </>
)

const tabs = [
  { id: 1, text: 'System templates' },
  { id: 2, text: 'My templates' }
]

const Templates = () => {
  const navigate = useNavigate()
  const defaultFilters = {
    page: 0,
    size: 50,
    active: true
  }
  const [rows, setRows] = useState([])
  const [totalCount, setTotalCount] = useState(null)
  const [filters, setFilters] = useState(defaultFilters)
  const [selectedIds, setSelectedIds] = useState([])
  const [activateAllChecked, setActivateAllChecked] = useState(false)
  const [selectedId, setSelectedId] = useState()

  const [openDrawer, setOpenDrawer] = useState(false)
  const [loading, setLoading] = useState(false)

  const [company, setCompany] = useState(null)
  const [services, setServices] = useState(null)
  const [servicesSelected, setServicesSelected] = useState([])
  const [chooseServicesDialog, setChooseServicesDialog] = useState(false)
  const [activeTab, setActiveTab] = useState(1)
  const [languages, setLanguages] = useState([])

  const { setSuccessMessage } = useContext(SnackBarContext)

  const userLocal = JSON.parse(localStorage.getItem('user'))
  const user = parseJwt(userLocal?.accessToken)

  const handleTabChange = name => {
    setLoading(true)
    setSelectedIds([])
    setActiveTab(tabs.find(el => el.text == name).id)
    setFilters(defaultFilters)
  }
  const openElement = id => {
    setSelectedId(id)
    setOpenDrawer(!openDrawer)
  }
  const [showMessage, setShowMessage] = useState(false)

  const handleFilter = param => {
    setLoading(true)

    setFilters({ ...filters, ...param })
  }
  const handleSelect = ids => {
    setActivateAllChecked(
      selectedIds.filter(el => rows.find(rowEl => rowEl.id == el)?.active).length == selectedIds.length
    )
    setSelectedIds(ids)
  }

  const activateSelected = () => {
    setActivateAllChecked(!activateAllChecked)
    templatesService.publishTemplate(!activateAllChecked, selectedIds).then(() => {
      setShowMessage(`You ${!activateAllChecked ? 'de' : ''}activated ${selectedIds.length} Templates`)
    })
  }

  useEffect(() => {
    setLoading(true)
    Promise.all([
      templatesService.getTemplates(),
      companyService.getCompany(user.companyId),
      templatesService.getServices(),
      companyService.getSimulationsLanguages()
    ])
      .then(
        values => {
          const [templatesResp, companyResp, servicesResp, langsResp] = values

          setLoading(false)
          setTotalCount(parseInt(templatesResp.headers['x-total-count']))
          setRows(templatesResp.data)

          setServicesSelected(companyResp.data.usedProducts || [])
          setCompany(companyResp.data)
          setServices(servicesResp.data)

          setLanguages(langsResp.data)
        },
        err => {
          if (err.response.status == 401) {
            navigate('/login')
          }
        }
      )
      .catch(err => {
        console.error(err)
        setLoading(false)
      })
  }, [])

  const onActivateOne = () => {
    setLoading(true)
    templatesService
      .getTemplates(filters)
      .then(data => {
        setLoading(false)
        setRows(data.data)
      })
      .catch(err => {
        console.error(err)
        setLoading(false)
      })
  }
  useEffect(() => {
    if (showMessage) {
      customToastWithAlert({
        message: showMessage,
        type: 'success'
      })
    }
  }, [showMessage])

  useEffect(() => {
    if (activeTab == 1) {
      templatesService
        .getTemplates({ ...filters, active: filters.active ? null : true })
        .then(resp => {
          setLoading(false)
          setTotalCount(parseInt(resp.headers['x-total-count']))
          setRows(resp.data)
        })
        .catch(err => {
          console.error(err)
          setLoading(false)
        })
    } else {
      templatesService
        .getCustomTemplatesNew(filters)
        .then(resp => {
          setLoading(false)
          setTotalCount(parseInt(resp.headers['x-total-count']))
          setRows(resp.data)
        })
        .catch(err => {
          console.error(err)
          setLoading(false)
        })
    }
  }, [filters])

  const handleSaveServices = () => {
    companyService
      .updateSelectedServices(user.companyId, {
        usedProducts: servicesSelected
      })
      .then(() => {
        setChooseServicesDialog(false)
        setSuccessMessage('Services updated')
      })
  }

  const toggleServices = service => {
    const servicesUpdated = servicesSelected?.includes(service)
      ? servicesSelected.filter(el => el !== service)
      : [...servicesSelected, service]
    setServicesSelected(servicesUpdated)
  }

  const onCloseServicesDialog = () => {
    setServicesSelected(company?.usedProducts || [])
    setChooseServicesDialog(false)
  }

  const selectAllServices = () => {
    if (servicesSelected.length == services.length) {
      setServicesSelected([])
    } else {
      setServicesSelected(services)
    }
  }

  const onShowAllTemplates = () => {
    setLoading(true)
    setFilters({ ...filters, active: !filters.active })
  }

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: 20 }} className='row row-center'>
        <h1 style={{ margin: 0, fontSize: 24 }}>Templates</h1>

        <div style={{ marginLeft: 30, borderBottom: 0 }} className='row tabs'>
          {tabs.map(el => (
            <div
              key={el.id}
              onClick={() => handleTabChange(el.text)}
              className={`tab ${activeTab == el.id && 'tab-active'}`}
              style={{ borderRadius: 8, padding: '6px 20px' }}
            >
              <p style={{ fontWeight: 600 }}>{el.text}</p>
            </div>
          ))}
        </div>
        <Spacer />
        {activeTab == 1 && (
          <div style={{ maxWidth: '300px' }} className='row'>
            <Button
              variant='outlined'
              onClick={() => setChooseServicesDialog(true)}
              sx={{
                borderColor: '#E7E7EE',
                borderRadius: '12px',
                color: '#6123FF',
                textTransform: 'none',
                flex: '1',
                mr: '12px',
                width: '262px'
              }}
              startIcon={<PuzzileIcon />}
            >
              Choose Services
            </Button>
            <ValueAndUnit val={servicesSelected?.length || 0} unit={'active'} />
          </div>
        )}
      </div>
      <DataGrid
        filters={filters}
        disableSelect={activeTab == 2}
        loading={loading}
        total={totalCount}
        onFilter={handleFilter}
        onOpenElement={openElement}
        bulkActions={<BulkActions onActivate={activateSelected} activateAllChecked={activateAllChecked} />}
        actions={activeTab == 1 && <Actions loading={loading} active={filters.active} onChange={onShowAllTemplates} />}
        rows={loading ? [] : rows}
        columns={activeTab == 1 ? columns(languages) : columnsCustom}
        selectedIds={selectedIds}
        onSelect={handleSelect}
        emptyListElement={<EmptyTemplates />}
      />
      <Drawer anchor='right' open={openDrawer} onClose={() => setOpenDrawer(false)}>
        <div
          style={{
            position: 'fixed',
            top: '24px',
            right: '1182px',
            cursor: 'pointer'
          }}
          onClick={() => setOpenDrawer(false)}
        >
          <CloseDrawer />
        </div>
        {activeTab == 1 ? (
          <TemplateView
            onActivate={onActivateOne}
            name={rows?.find(el => el.id == selectedId)?.name}
            language={rows?.find(el => el.id == selectedId)?.language}
          />
        ) : (
          <CustomTemplatePreview id={selectedId} />
        )}
      </Drawer>

      <Dialog
        sx={{ '& .MuiPaper-root': { borderRadius: '22px' } }}
        open={chooseServicesDialog}
        onClose={onCloseServicesDialog}
      >
        <DialogTitle
          sx={{
            fontFamily: 'Satoshi',
            fontStyle: 'normal',
            fontWeight: '900',
            fontSize: '35px',
            lineHeight: '110%',
            color: '#1B1B26'
          }}
        >
          Phishing Simulations
        </DialogTitle>
        <DialogContent sx={{ width: '600px' }}>
          <p style={{ marginBottom: '25px' }}>
            To avoid sending phishing emails related to services that your employees do not use, choose the services
            that are commonly used in your company
          </p>
          <div className='column'>
            <div className='row row-center'>
              <CustomCheckbox onChange={selectAllServices} checked={servicesSelected?.length == services?.length} />
              <p>Select All</p>
            </div>
            <Divider />
            {services &&
              services.map(el => (
                <div key={el} className='row row-center'>
                  <CustomCheckbox
                    onChange={() => toggleServices(el)}
                    checked={servicesSelected?.includes(el) || false}
                  />
                  <p>{el}</p>
                </div>
              ))}
          </div>
        </DialogContent>
        <Divider />
        <div className='row'>
          <Button
            onClick={onCloseServicesDialog}
            sx={{
              height: '60px',
              borderRadius: '14px',
              color: '#6123FF',
              borderColor: '#6123FF',
              flex: '1',
              margin: '24px 16px 24px 32px'
            }}
            variant={'outlined'}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveServices}
            sx={{
              height: '60px',
              borderRadius: '14px',
              backgroundColor: '#6123FF',
              flex: '1',
              margin: '24px 32px 24px 0px'
            }}
            variant={'contained'}
          >
            Save
          </Button>
        </div>
      </Dialog>
    </div>
  )
}

export default Templates
